import type { IncomingMessage } from 'node:http';

export function readBearerToken(req: IncomingMessage): string | null {
  const raw = req.headers.authorization;
  if (typeof raw !== 'string') return null;
  const match = /^Bearer\s+(.+)$/i.exec(raw.trim());
  return match?.[1]?.trim() ? match[1].trim() : null;
}

export function isAuthorizedShortcutRequest(req: IncomingMessage, expectedToken: string): boolean {
  const token = readBearerToken(req);
  return Boolean(token && expectedToken && token === expectedToken);
}
